import React from "react";
import { FormGroup, FormControl, InputLabel, Select, MenuItem, FormHelperText } from "@material-ui/core"
import { useField } from "react-final-form-hooks";

export default function ({ form, name, label, icon, type, children, hint, options, hidden,  ...props }) {
    const field = useField(name, form);
    const [labelWidth, setLabelWidth] = React.useState(0);
    const inputLabel = React.useRef(null);
    React.useEffect(() => {
      setLabelWidth((inputLabel.current && inputLabel.current.offsetWidth) || 200);
    }, []);

    const onChange = (event, child) => {
        if (type === "boolean") {
          field.input.onChange(event.target.value === "true" || event.target.value);
          return;
        }
        field.input.onChange(event.target.value);
    }
    let selectItems = (options || []).map((_option) => {
        return (
            <MenuItem value={_option.value} key={_option.value}>{_option.label}</MenuItem>
        );
    })

    if(hidden){
        return null;
    }

    return (
        <FormGroup>
            <FormControl
              fullWidth
              margin="normal"
              size="small"
              error={field.meta.touched && field.meta.error}
              variant="outlined"
            >
                <InputLabel ref={inputLabel} htmlFor={`html_components_${name}`}>{label}</InputLabel>
                <Select
                    id={`html_components_${name}`}
                    inputProps={{
                        name,
                        id: `html_components_${name}`,
                    }}
                    displayEmpty
                    labelWidth={labelWidth}
                    { ...field.input }
                    onChange={onChange}
                >
                    { selectItems }
                </Select>
                {(field.meta.touched && field.meta.error) ? <FormHelperText>{field.meta.error}</FormHelperText> : null}
            </FormControl>
        </FormGroup>
    );
}
